import { render, staticRenderFns } from "./studentStudy.vue?vue&type=template&id=15fbe6a5&scoped=true&"
import script from "./studentStudy.vue?vue&type=script&lang=js&"
export * from "./studentStudy.vue?vue&type=script&lang=js&"
import style0 from "./studentStudy.vue?vue&type=style&index=0&id=15fbe6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbe6a5",
  null
  
)

export default component.exports